/**
 * Qué hacer cuando una navegación falla porque no cargó el chunk de la pantalla de destino.
 *
 * Los chunks se cargan como `<script type="module">`, y el navegador guarda en el module map del
 * documento el fallo de un módulo: la misma URL vuelve a fallar al instante, sin pedirse a la red, hasta
 * que se abre otro documento. Por eso reintentar la navegación no alcanza y hay que recargar. Vale para
 * cualquier tipo de fallo de carga, también el de `timeout`: un chunk colgado tampoco se vuelve a pedir, y
 * el reintento termina con el resultado del pedido original.
 */

export function isChunkLoadError(error: unknown): boolean {
  return (error as { name?: unknown } | null)?.name === 'ChunkLoadError';
}

/**
 * Sin red, recargar abre la página de error del navegador, y el asegurado pierde la pantalla que le
 * explica qué pasó. Ahí se queda donde está y vuelve a intentar al tocar.
 */
export function shouldReloadAfterNavigationError(error: unknown, online: boolean): boolean {
  return online && isChunkLoadError(error);
}
